"use strict";

import { creditCardPayments } from "../_constants";

const INITIAL_CREDIT_CARD_PAYMENTS_DATA_STATE = {
  readyToPay: false,
  creditCardBillPaymentFLowData: {},
  dfccOtherCreditCardDetails: {},
  payFromList: [],
  isFeatureAvailable: false,
  validateBillPaymentData: {},
  selectedPayeeData: {},
  payBillData: {},
  cardPayOtpTimer: 0,
  isPayeeTypeListLoading: false,
  payeeTypeList: [],
  payToBanks: [],
};

export function creditCardPaymentsReducer(
  state = INITIAL_CREDIT_CARD_PAYMENTS_DATA_STATE,
  action,
) {
  switch (action.type) {
    case creditCardPayments.VALIDATE_CLIENT_OTHER_CARD_REQUEST:
      return {
        ...state,
        dfccOtherCreditCardDetails: {},
        isFeatureAvailable: false,
      };

    case creditCardPayments.VALIDATE_CLIENT_OTHER_CARD_COMPLETE:
      return {
        ...state,
        dfccOtherCreditCardDetails:
          action.payload?.data?.creditCardBankIdentificationDto,
        isFeatureAvailable: false,
      };

    case creditCardPayments.VALIDATE_CLIENT_OTHER_CARD_ERROR:
      return {
        ...state,
        dfccOtherCreditCardDetails: {},
        isFeatureAvailable: false,
      };

    case creditCardPayments.CREDIT_CARD_PAY_FROM_LIST_REQUEST:
      return {
        ...state,
        payFromList: [],
        readyToPay: false,
        isFeatureAvailable: false,
      };

    case creditCardPayments.CREDIT_CARD_PAY_FROM_LIST_COMPLETE:
      return {
        ...state,
        payFromList: action.payload?.data?.accountList,
        readyToPay: true,
        isFeatureAvailable: false,
      };

    case creditCardPayments.CREDIT_CARD_PAY_FROM_LIST_ERROR:
      return {
        ...state,
        payFromList: [],
        readyToPay: true,
        isFeatureAvailable: false,
      };

    case creditCardPayments.CREDIT_CARD_VALIDATE_AMOUNT_REQUEST:
      return {
        ...state,
        validateBillPaymentData: [],
        ownFormData: action.payload?.restoreData,
        selectedPayeeData: action.payload?.payeeData,
        isFeatureAvailable: false,
      };

    case creditCardPayments.CREDIT_CARD_VALIDATE_AMOUNT_COMPLETE:
      return {
        ...state,
        validateBillPaymentData: action.payload.data,
        isFeatureAvailable: false,
      };

    case creditCardPayments.CREDIT_CARD_VALIDATE_AMOUNT_ERROR:
      return {
        ...state,
        validateBillPaymentData: action.payload.response?.errorResponse,
        isFeatureAvailable: false,
      };

    case creditCardPayments.SET_CREDIT_CARD_BILL_PAYMENT_FLOW:
      return {
        ...state,
        validateBillPaymentData: {},
        creditCardBillPaymentFLowData: action.payload,
        isFeatureAvailable: false,
      };

    case creditCardPayments.CREDIT_CARD_CLEAR_FLOW_DATA:
      return {
        ...state,
        validateBillPaymentData: {},
        dfccOtherCreditCardDetails: {},
        selectedPayeeData: {},
        payBillData: {},
        cardPayOtpTimer: 0,
        isFeatureAvailable: false,
        readyToPay: false,
      };

    case creditCardPayments.CREDIT_CARD_CLEAR_FORM_DATA:
      return {
        ...state,
        ownFormData: {},
      };

    case creditCardPayments.CREDIT_CARD_PAY_BILL_REQUEST:
      return {
        ...state,
        payBillData: {},
        cardPayOtpTimer: 0,
        isFeatureAvailable: false,
      };

    case creditCardPayments.CREDIT_CARD_PAY_BILL_COMPLETE:
      return {
        ...state,
        payBillData: action.payload.data,
        cardPayOtpTimer: action.payload.data?.otpTimerTimePeriod,
        isFeatureAvailable: false,
      };

    case creditCardPayments.CREDIT_CARD_PAY_BILL_ERROR:
      return {
        ...state,
        payBillData: {},
        cardPayOtpTimer: 0,
        isFeatureAvailable: false,
      };

    case creditCardPayments.CREDIT_CARD_OTP_CONFIRMATION_COMPLETE:
      return {
        ...state,
        payBillData: action.payload.data,
        cardPayOtpTimer: 0,
        isFeatureAvailable: false,
      };

    case creditCardPayments.CREDIT_CARD_OTP_CONFIRMATION_ERROR:
      return {
        ...state,
        // payBillData: action.payload.response.errorResponse,
        isFeatureAvailable: false,
      };

    case creditCardPayments.CARD_SETTLEMENT_TYPES_REQUEST:
      return {
        ...state,
        isPayeeTypeListLoading: true,
        payeeTypeList: [],
        isFeatureAvailable: false,
      };

    case creditCardPayments.CARD_SETTLEMENT_TYPES_COMPLETE:
      return {
        ...state,
        isPayeeTypeListLoading: false,
        isFeatureAvailable: true,
        payeeTypeList: action.payload.data.payeeTypeList,
      };

    case creditCardPayments.CLEAR_CREDIT_CARD_AVAILABLE_STATUS:
      return {
        ...state,
        isFeatureAvailable: false,
      };

    case creditCardPayments.CARD_SETTLEMENT_TYPES_ERROR:
      return {
        ...state,
        isFeatureAvailable: false,
        isPayeeTypeListLoading: false,
        payeeTypeList: [],
      };

    case creditCardPayments.CREDIT_CARD_PAY_TO_BANKS_REQUEST:
      return {
        ...state,
        isFeatureAvailable: false,
        payToBanks: [],
      };

    case creditCardPayments.CREDIT_CARD_PAY_TO_BANKS_COMPLETE:
      return {
        ...state,
        isFeatureAvailable: false,
        payToBanks: action.payload.data?.bankList,
      };

    case creditCardPayments.PAY_TO_BANKS_ERROR:
      return {
        ...state,
        isFeatureAvailable: false,
        payToBanks: [],
      };

    case creditCardPayments.SET_PAY_FROM:
      return {
        ...state,
        ownFormData: {
          ...state.ownFormData,
          payFrom: action.payload,
        },
      };
  }
  return state;
}
